import React, { Component } from 'react';
import Radium from 'radium';


class BubbleTick extends Component {
	render() {
		return (
			<svg width="10px" height="9px" viewBox="0 0 10 9" version="1.1">
				<defs>
					<linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id={this.props.id}>
						<stop stopColor={this.props.color2} offset="0%"></stop>
						<stop stopColor={this.props.color1} offset="100%"></stop>
					</linearGradient>
				</defs>
				<g id={`${this.props.id}Landing`} stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g id={`Group_${this.props.id}`} fill={`url(#${this.props.id})`}>
						<path d="M9.69008877,0.259983976 C10.0809747,0.624491035 10.1023591,1.23685807 9.737852,1.62774404 L4.01786576,7.76167831 C3.98893476,7.79878569 3.96209972,7.8292464 3.93302844,7.85831769 C3.5551017,8.23624443 2.9423614,8.23624443 2.56443467,7.85831769 L0.28344505,5.57732807 C-0.0944816835,5.19940134 -0.0944816835,4.58666104 0.28344505,4.2087343 C0.661371784,3.83080757 1.27411209,3.83080757 1.65203882,4.2087343 L3.221,5.777 L8.32232871,0.30774721 C8.68683577,-0.0831387538 9.29920281,-0.104523082 9.69008877,0.259983976 Z" id="Combined-Shape"></path>
					</g>
				</g>
			</svg>
		);
	}
}

export default Radium(BubbleTick);


// WEBPACK FOOTER //
// ./src/components/BubbleTick.js